module.exports = __webpack_public_path__ + "static/media/infoNew.5ec50c5e.svg";